import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';
import { MenuService } from '../../core/services/menu.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        <ng-container *ngFor="let item of model; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul> `
})
export class AppMenu implements OnInit {
  menuService = inject(MenuService);
  model: any[] = [];

  async ngOnInit(): Promise<void> {
    // ใช้ firstValueFrom เพื่อรอค่าจาก BehaviorSubject หรือ Observable
    let menus = await firstValueFrom(this.menuService.getMenuItem());
    
    // ถ้าไม่เจอ (null, undefined หรือไม่มีเมนู), ให้เรียก API getMenusByRoleId ใหม่
    if (!menus || menus.length === 0) {
      const resp = await firstValueFrom(this.menuService.getMenusByRoleId());
      menus = resp.menus || [];
    }

    // เคลียร์ model ก่อนป้องกัน push ซ้ำซ้อน
    this.model = [];

    // Loop push เมนู + details
    menus.forEach(menu => {
      this.model.push({
        label: menu.menuName,
        items: menu.details.map(detail => ({
          label: detail.menuName,
          icon: detail.menuIcon,
          routerLink: [detail.menuUrl]
        }))
      });
      this.model.push({ separator: true });
    });
  }
}
